// extracted by mini-css-extract-plugin
module.exports = {"content":"e_dE","blockTitle":"e_eE","source":"e_fE"};